import React, { useState } from 'react';

import { FilterContainer, Title, Hr, CheckboxContainer } from '../cmsAllChallenges/styles';
import { Checkbox } from 'components/Checkbox/Checkbox';

export default function Filter({ filterOptions, filterValues }) {
  const [filter, setFilter] = useState(filterOptions);

  const setValue = (change) => {
    let filterCopy = { ...filter, ...change };
    setFilter(filterCopy);
    return filterValues(filterCopy);
  };

  return (
    <FilterContainer id="customTestsFilter">
      <Title>Filter</Title>
      <Hr />
      <CheckboxContainer>
        <Checkbox checked={filter.active} onChange={() => setValue({ active: !filter.active })} label="Active" />
        <Checkbox
          checked={filter.inactive}
          onChange={() => setValue({ inactive: !filter.inactive })}
          label="Not Active"
        />
      </CheckboxContainer>
    </FilterContainer>
  );
}
